export const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    if (!file || typeof file !== 'object') {
      reject(new Error('Invalid file'));
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(new Error(error));
  });
